export const QA_NAME_PROFILE_MORE_MENU = 'profileMoreMenu'
